export default __webpack_public_path__ + "static/media/Background_00230.46f832d7.png";